// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ig-0";